export enum ConferencingServiceProviders {
    Zoom = 'Zoom',
    Teams = 'Microsoft Teams Meeting',
    GoToMeeting = 'GoToMeeting',
    Webex = 'Webex',
    ZoomOAuth = 'ZoomOAuth',
    PopIo = 'POPi/o',
    ZoomServerToServerOAuth='ZoomServerToServerOAuth'
}
